import { render, staticRenderFns } from "./UserInfoEdit.vue?vue&type=template&id=2268f93c&"
import script from "./UserInfoEdit.vue?vue&type=script&lang=js&"
export * from "./UserInfoEdit.vue?vue&type=script&lang=js&"
import style0 from "./UserInfoEdit.vue?vue&type=style&index=0&id=2268f93c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports